'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import { api } from '@/server/callers/client';
import { getFileUrl } from '@/utils/helpers';

export default function BookingHero() {
  const params = useParams<{ destination: string; trip: string }>();

  const { data: tripData, isLoading } = api.trips.get.useQuery({
    slug: params.trip as string,
  });

  const { data: destinationData } = api.destinations.get.useQuery({
    slug: params.destination as string,
  });

  if (isLoading || !tripData) {
    return (
      <div className="w-full h-[40vh] bg-gray-200 animate-pulse flex items-center justify-center">
        <p className="text-gray-500">Loading trip information...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center relative lg:w-[50vw] h-[70vh] lg:h-screen text-white">
      <Image
        src={getFileUrl(tripData.cover?.key, 'image')}
        alt={`${destinationData?.name || 'Destination'} - ${tripData.name} travel destination`}
        width={1920}
        height={1080}
        priority
        className="absolute inset-0 object-cover w-full h-full -z-1"
      />
      <div
        className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/20 pointer-events-none -z-1"
        aria-hidden="true"
      />
      <div
        data-aos="fade-up"
        className="w-full container px-4 md:px-16 mx-auto flex flex-col align-start text-start"
      >
        <h1 className="text-4xl md:text-7xl font-[500] pb-6 mt-28">
          {destinationData?.name || 'Destination'}
          <Link
            href={`/destinations/${destinationData?.slug}/${tripData.slug}`}
            className="text-accent block"
          >
            {tripData.name}
          </Link>
        </h1>
        <p className="text-lg md:text-xl font-[300] max-w-2xl">
          {tripData.overview ||
            'Explore our wide range of destinations, from the mountains to the sea, and beyond.'}
        </p>
      </div>
    </div>
  );
}
